// components/ActionsCell.js
import {Button} from "antd";
import {SettingOutlined} from "@ant-design/icons";
import {memo} from "react";

export const ActionsCell = memo(({record, onEdit}) => (
    <Button
        type="text"
        icon={<SettingOutlined/>}
        onClick={() => onEdit(record)}
        style={{color: '#1890ff'}}
    />
));

ActionsCell.displayName = 'ActionsCell';